import styles from './VModal_3Rules18_9.module.css'
import buttons from '../../../../common/Buttons.module.css'

import PopupAppearLayout from '../../Layouts/PopupAppearLayout'
import { useModalWindow } from "react-modal-global";
import useScrollBlock from '../../../../../../customHooks/useScrollBlock';
// Images
import image_rules_1 from "../../../../assets/img/by_page/rules_18_9/rules_1.png"
import image_rules_2 from "../../../../assets/img/by_page/rules_18_9/rules_2.png"
import image_rules_3 from "../../../../assets/img/by_page/rules_18_9/rules_3.png"

const VModal_3Rules18_9 = () => {
  const modal = useModalWindow();
    const [blockScroll, allowScroll] = useScrollBlock();

    const closeModal = () => {
      // setTimeout(function(){allowScroll()}, 150);
      // defaultThemeColor()
      allowScroll()
      modal.close()
    } 

    return (
      <PopupAppearLayout classNameLayout={styles.popup__layout}>
        
            <h2 className={styles.title}>Условия обмена/возврата тары</h2>
            <p className={styles.main_text}>При приеме от потребителей пустой оборотной тары – бутылей объемом 18,9 л необходимо соблюдать следующие правила:</p>
            <ol className={styles.main_list_numbered}>
              <li className={styles.list_item_numbered}>Бутыль должен быть изготовлен из материала поликарбонат, с ручкой или без ручки.</li>
              <li className={styles.list_item_numbered}>На дне бутыли должна быть нанесена аббревиатура в виде петли Мебиуса в форме треугольника с цифрой « 7 », выбитой внутри петли. Под треугольником нанесены буквенные обозначения РС, так же на дне бутыли  указаны (выбиты) месяц и год выпуска и производитель тары «AQUA WELL»</li>
              <li>
                <p className={styles.list_item_numbered}>Состояние тары при приемке:</p>
                <ul className={styles.list}>
                  <li>Без посторонних предметов и мусора внутри бутыли</li>
                  <li>Без физических повреждений и деформаций</li>
                  <li>Без трещин, сколов, порезов, вмятин, следов потертостей, без помутнения или изменения цвета</li>
                  <li>Без следов химического воздействия</li>
                  <li>Без пятен краски, технического масла</li>
                  <li>Без признаков застоя воды, бактериального и грибкового роста, без образования зеленого налета на стенках бутыли</li>
                  <li>Без слизи, без бурого и черного цвета налета</li>
                  <li>Без плесени и загрязнений на поверхности</li>
                  <li>Без посторонних запахов</li>
                  <li>Без гравировки логотипа от других производителей на  боковой стенке бутыли</li>
                </ul>
              </li>
            </ol>
            
            <div className={styles.image_container}>
                <img className={styles.image_rule} src={image_rules_1} alt='bottle bottom' />
                <img className={styles.image_rule} src={image_rules_2} alt='bottle bottom' />
                <img className={styles.image_rule} src={image_rules_3} alt='bottle bottom' />
            </div>
            <div className={styles.btn_container}>
                <button onClick={closeModal} className={buttons.btn_solid_blue}>закрыть</button>
            </div>
          

      </PopupAppearLayout>

    )
}

export default VModal_3Rules18_9